<template>
<Mainpage :showHeader="false" :storeid="storeid" v-if="this.giftCartItems.length > 0">
  <div v-if="isMobile()">
    <router-link
          v-if="isMobile()"
          class="d-flex gift-card-button"
          :to="{
            name: 'giftcheckbalance',
          }"
        >
          <img
            src="../../assets/images/button-icons/gift-card-icon.svg"
            alt="gift card balance icon"
          />
          Check your Gift Card Balance
    </router-link>
  </div>
  <div class="d-flex flex-wrap">
      <div class="col-12 col-sm-8 p-3 left-section">
        <div class="left-section__main">
          <div v-if="isGoogle">
            <label class="title6">Checkout</label>
            <br />
            <button class="btn-block gpay-button title7">
              Pay with<img
                class="purchase_image ml2"
                src="../../assets/images/logos/googlepay-logo.svg"
                alt="purchase logo"
              />
            </button>
            <div class="w-divider mt-2 title6-5" >Or Pay with Card</div>
          </div>

          <form @submit.prevent="onSubmit" >
            <div v-if="isAddCard" class="add-card" >
              <checkout-component
              ref="myDetails"
              :edit-model="detailModel"
              :cardModel="paymentModel"/>

              <button
                type="submit"
                class="btn btn-primary btn-block mt-2"
                :style="{ backgroundColor: '#3862eb' }"
              >
                Confirm Payment
              </button>
            </div>

            <!-- <div v-if="!isAddCard" class="use-car">
              <div class="form-group mt2">
                <button
                  type="button"
                  class="btn btn-primary btn-block mt-2"
                  :style="{ backgroundColor: '#3862eb' }"
                  @click="isAddCard = true"
                >
                  Add New Card
                </button>
                <label class="title6-5 mt-4">Saved Cards </label>
                <select class="form-select w-100" aria-label="Default select example">
                  <option
                    v-for="card in giftState.buyCardForm.savedCards"
                    :key="card"
                  >
                    {{ card }}
                  </option>
                </select>

                <button
                  type="submit"
                  class="btn btn-primary btn-block mt-4"
                  :style="{ backgroundColor: '#3862eb' }"
                >
                  Confirm Payment
                </button>
              </div>
            </div> -->
          </form>
        </div>
        <div
          v-if="isMobile()"
          class="text-center mt-4 body left-footer"
        >
          Powered By
          <img
            class="footer-image"
            src="../../assets/images/logos/ABACUS_Logo_White.svg"
            alt="abacus white logo"
          />
        </div>
      </div>

      <!-- right section -->
      <div class="col-12 col-sm-4 p-3 right-section">
        <div class="right-top-section px2">My Order</div>
        <div class="right-bottom-section px2">
          <div class="card-container mt-4">
            <Card
              :imageUrl="getBackgroundImage()"
              :cardContent="
                giftCartItems[0].name
              "
              :cardValue="giftState.cardValue"
              :colorStyle="giftState.curValueListIndex === 1 ? '#5D77BC' : ''"
            />
          </div>

          <div class="d-flex mt-4 justify-content-between"> 
            <div>${{ giftCartItems[0].price }}.00</div>
            <div>
              <a href="" class="link">
                <router-link :to="{name:'giftstore'}">Edit Card</router-link>
              </a>
            </div>
          </div>

          <div class="recipient-info mt-4 pb-5">
            <div class="d-flex justify-content-start"> 
              <div class="col-5 p-1 title7">Recipient's Name</div>
              <div class="col-5 p-1 title7">Recipient's Email</div></div
            >
            <div class="d-flex justify-content-start"> 
              <div class="col-5 p-1 title5-5">
                {{ giftCartItems[0].message.To }}
              </div>
              <div class="col-5 p-1 title5-5">
                {{ giftCartItems[0].message.Email }}
              </div>
            </div>
          </div>

          <div class="w-divider" :style="{ color: '#E3E6EA' }"></div>

          <div class="pt-2 pb-4 title5-5">
            <div class="d-flex justify-content-between">
              <div>Subtotal</div>
              <div>${{ giftCartItems[0].price }}.00</div>
            </div>
            <div class="d-flex justify-content-between">
              <div>Discount</div>
              <div>$0.00</div></div
            >
            <div class="d-flex justify-content-between">
              <div>Surcharge</div>
              <div>{{getGiftSurchargeAmount}}</div></div
            >
          </div>

          <div class="w-divider" :style="{ color: '#E3E6EA' }"></div>
          <CouponComponent ref="couponComponent" :className="'cart-totals'" class="p-0 mb-2 mt-4"></CouponComponent>
          <!-- <div class="input-group mb-2 mt-4">
            <input
              type="text"
              class="form-control"
              placeholder="Discount Code"
              aria-label="Recipient's username"
              aria-describedby="button-addon2"
              v-model="couponCode"
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              id="button-addon2"
              @click="
                () => {
                  couponList.push(couponCode);
                }
              "
            >
              Apply
            </button>
          </div> -->
          <div
            v-for="(coupon, index) in couponList"
            :key="coupon"
            @click="
              () => {
                couponList.splice(index, 1);
              }
            "
            class="coupon-tag p-1"
          >
            <!-- <w-icon sm xl color="white"> mdi mdi-tag-outline </w-icon>
            COUPON{{ couponList[index] }}
            <w-icon sm class="mr1 pointer" xl color="white">
              mdi mdi-window-close
            </w-icon> -->
          </div>

          <div class="w-divider mt-2"  :style="{ color: '#E3E6EA' }"></div>

          <div class="sum-section mt-2">
            <div class="d-flex justify-content-between">
              <div
                :class="`col-4 ${isMobile() ? 'title4' : 'title5'}`"
              >
                Total
              </div>
              <div
                :class="`col-3 ${
                  isMobile()
                    ? 'title4 text-end'
                    : 'title5 text-end'
                }`"
              >
                {{giftTotalPrice | formatMoney}}
              </div>
            </div>
          </div>

          <GiftCardFooter v-if="!isMobile()" :showSub="false" class="mt-5" />
        </div>
      </div>

    
    <!-- the overlay for showing transaction dealing progress -->
    <div class="w-overly" v-if="showOverlay">
      <!-- when transaction is in progress -->
      <div class="transaction-box transaction-box col-4" v-if="isLoading">
        <div class="spin-lg" ></div>
        <h3
          class="text-center"
        >
          {{ processText }}
        </h3>
        <p class="text-center">
          {{ processDescription }}.
        </p>
      </div>

      <!-- when transaction success -->
      <div v-if="!isLoading && isSuccess"
        class="transaction-box transaction-box col-4 success-box"
      >
        <img
          src="../../assets/images/icons/transaction-success.png"
          class="transaction-icon"
          alt="payment success"
        />
        <h3
          class="text-center"
        >
          Payment Complete
        </h3>
      </div>

      <!-- when transaction is failed -->
      <div v-if="!isLoading && !isSuccess" 
        class="transaction-box col-4 error-box"
      > 
        <img
          src="../../assets/images/icons/transaction-failed.png"
          class="transaction-icon"
          alt="payment failed"
        />
        <h3
          class="text-center"
        >
          Payment could not be processed
        </h3>
        <router-link :to="{name: 'giftstore'}">
          <button class=" btn body"
            >Continue Ordering</button
          ></router-link
        >
      </div>
    </div>
  </div>
</Mainpage>
</template>

<script lang="ts">
import { mask } from "vue-the-mask";
import Card from "./Card.vue";
import store from "../../../src/store";
import Mainpage from "./Mainpage.vue";
import GiftCardFooter from "./GiftCardFooter.vue";
import { mapMutations, mapGetters, mapActions } from "vuex";
import CouponComponent from "../shop/shopping-cart/CouponComponent.vue";
import shared from "../../sharedscripts/shop/Checkout/giftCheckout.js";
import shares from "../../sharedscripts/shop/shopping-cart/ShoppingCart";
import CheckoutComponent from "./CheckoutComponent.vue"
export default {
  name: "ConfirmPayment",
  directives: { mask },
  components: {
    Card,
    CouponComponent,
    Mainpage,
    GiftCardFooter,
    CheckoutComponent
  },
  data() {
    return {
      showOverlay: false,
      progress: 0,
      isLoading: false,
      isSuccess: true,
      couponList: [],
      isAddCard: true,
      isGoogle: false,
      couponCode:null,
      giftcardCode: 111,
      giftState: store.getters.allGiftState,
      cardCVC: null,
      cardDate: null,
      cardNumber: null,
      email:null,
      giftcardItem: null,
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null
      },
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: ""
      },
      paymentMethod: 1,
      guestUserId: null,
      store: null
    }
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["giftCartItems","giftDiscount","selectedCompany","storeMenu"]),
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  created() {
    this.store = this.currentStoreDoc;
    if(this.giftCartItems.length == 0)
    {
      this.$router.push({
        name: "giftstore",
        params: {
          storeid: this.storeid,
          storename: this.$route.params.storename,
          isGift: true
        }
      });
    }
  },
  methods: {
    ...shares.methods,
    ...shared.methods,
    ...mapMutations(["setStoreLoaded"]),
    ...mapActions(["setCardNumber", "clearCardType"]),

    async onSubmit() {
      this.showOverlay = true;
      this.isLoading = true;
      this.placeOrder();
      
    },
    getBackgroundImage() {
      let temp = null;
      var storemenu = JSON.parse(JSON.stringify(this.storeMenu))
      storemenu.SpecialCategories.SCTypeGiftcard.SubMenuItems.forEach(
        (element) => {
          if (storemenu.Products[element.ProductID] && this.giftCartItems[0].id == element.ProductID) {
           temp = element;
          }
        }
      );
      if(temp && temp.PhotoUrl)
      {
        return temp.PhotoUrl;
      }else
      {
        return this.giftState.cardUrl;
      }
      
    },
  },
  watch: {
    giftTotalPrice() {
      this.giftComputeRules();
    },
    "paymentModel.CardNumber": function (val) {
      this.$validator.validate("cardNumber").then((res) => {
        setTimeout(() => {
          if (res) this.setCardNumber(val);
            else this.clearCardType();
        }, 1);
      });
    },
    "paymentModel.ExpireDate": function (newValue) {
      if (newValue.length > 4) {
        let splitedValue = newValue.split("/");
        if (splitedValue[0] > 12) {
          this.editModel.ExpireDate = splitedValue[1] + "/" + splitedValue[0];
        }else if (splitedValue[1].length > 3)
        {
          this.editModel.ExpireDate = splitedValue[0] + "/" + splitedValue[1].slice(-2);
        }
      }
    },
  },
  mounted(){
    this.setStoreLoaded();
  },

  processText() {
      if(this.isPayLater) {
        return this.isPending
          ? this.$t("message.processingOrder")
          : this.succeeded
          ? this.$t("message.orderCompleted")
          : this.$t("message.orderCouldNotBeProcessed");
      } else {
        return this.isPending
          ? this.$t("message.processingPayment")
          : this.succeeded
          ? this.$t("message.paymentComplete")
          : this.$t("message.PaymentCouldNotBeProcessed");
      }
    },
    processDescription() {
      return this.isPayLater
        ? this.$t("message.pleaseDoNotRefreshYourBrowserWhileTheOrderIsBeingProcessed")
        : this.$t("message.pleaseDoNotRefreshYourBrowserWhilePaymentIsBeingProcessed");
    }

};
</script>

<style scoped>

.w-divider {
    border: 0 solid rgba(0, 0, 0, 0.15);
    border-top-width: 1px;
}

.w-overlay[data-v-648cce40] {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.w-overlay {
    z-index: 500;
    position: fixed;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
}
.logo-section {
  border-bottom: 1px solid rgb(128, 128, 128, 0.3);
  width: 100%;
  height: 8%;
}
.gift-card-button {
  background-color: #ffffff;
  font-family: Open Sans;
  margin-top: 1%;
  color: black;
  position: absolute;
  top: 10px;
  right: 45px;
}
.left-section__main {
  padding: 5% 20% 10%;
  height: 92%;
}
.giftcard-wrapper {
  height: 92%;
  width: 100%;
  padding: 2% 24%;
  box-sizing: border-box;
}
.logo-section {
  border-bottom: 1px solid rgb(128, 128, 128, 0.3);
  margin: 0 2%;
  width: auto;
  height: 8%;
}
.right-top-section {
  border-bottom: 1px solid rgb(128, 128, 128, 0.3);
  width: 100%;
  height: 5%;
}

.btn-block {
  width: 100%;
}
.gpay-button {
  border: 1px solid #d3d8de;
  border-radius: 4px;
  padding: 0.3rem;
}
.purchase_image {
  width: 16%;
}
.form-control {
  padding-top: 0;
  padding-bottom: 0;
}
.form-control::placeholder {
  font-size: 0.7rem;
  font-weight: 400;
  color: #969da2;
}
input input:focus {
  outline: none;
  -webkit-appearance: none;
}
.coupon-tag {
  background-color: #3862eb;
  font-size: 0.8rem;
  color: rgb(255, 255, 255);
  width: fit-content;
  border-radius: 4px;
}
.pointer:hover {
  cursor: pointer;
}
.footer-image {
  width: 35%;
  margin-top: -4px;
}
.w-overlay {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.right-section {
  background-color: #fafafa;
  overflow: hidden;
}

@media only screen and (max-width: 900px) {
  #top {
    background-image: none;
    height: 0;
  }
  .gift-card-button {
    color: #55a7ff;
    z-index: 2;
    border: none;
  }

  .right-section {
    order: 1;
    -webkit-order: 1;
    background-color: #ffffff;
    height: fit-content;
    overflow: visible;
  }
  .left-section {
    order: 2;
    -webkit-order: 2;
  }
  .right-top-section {
    border: none;
    font-size: 20px;
    font-weight: 400;
    margin-top: 1rem;
  }
  #button-addon2 {
    border-radius: 0;
    background-color: #000000;
    color: #ffffff;
    margin-left: 1rem;
  }
  .sum-section {
    margin-top: 1rem;
  }
  .gpay-button {
    width: 100%;
  }
  .left-section__main {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .left-footer {
    margin-top: 0.5rem;
  }
}
.title7 {
    font-size: 11px;
    font-weight: 400;
    color: #969da2;
}
.title5-5 {
    font-size: 11px;
    font-weight: 500;
    color: #767575;
}

.w-overly {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.w-overly {
    background-color: rgba(255,255,255,.3);
    z-index: 500;
    position: fixed;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
}
.transaction-icon {
  width: 100px;
}
.transaction-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
  gap: 20px;
}

.error-box h3{
  color: red;
}
.error-box button{
  background-color: #f65555;
}

.success-box h3 {
  color: green;
}
</style>
